/**
 * AccessTokenæ°æ®ç±»å
 */
export class NecAccessToken {
  /**
   * å£ä»¤å­æ®
   */
  access_token: string;

  /**
   * è¿ææ¶é´(å¤å°ç§åè¿æ)
   */
  expires_in: number;

  /**
   * è¿ææ¶é´(åªä¸ªæ¶é´æ³åè¿æ)
   */
  expire_time: number;

  /**
   * åæ¬¡è·åå£ä»¤çå­æ®
   */
  refresh_token: string;

  /**
   * ä½ç¨å, ä¸è¬ä¸º'read'
   */
  scope: string;

  /**
   * ç±»å, ä¸è¬ä¸º'bearer'
   */
  token_type: string;
}
